import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'active-offers-campaigns-discard-reasons',
  storeModule.createStoreModule('active-offers-campaigns-discard-reasons')
)
